import apiClient from './client';
import { endpoints } from './endpoints';
import type { Training } from '@/types';

export const trainingService = {
  async list(filters: Record<string, unknown> = {}): Promise<Training[] | unknown> {
    const response = await apiClient.get(endpoints.trainings.list, { params: filters });
    return response.data;
  },
  async get(idOrSlug: string): Promise<Training | unknown> {
    const response = await apiClient.get(endpoints.trainings.get(idOrSlug));
    return response.data;
  },
  async create(trainingData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.post(endpoints.trainings.create, trainingData);
    return response.data;
  },
  async update(id: string, trainingData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.put(endpoints.trainings.update(id), trainingData);
    return response.data;
  },
  async delete(id: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.trainings.delete(id));
    return response.data;
  },
};

export default trainingService;
